/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';

export interface RemoveMenuSubcategory$Params {
  menuCategoryId: string;
  menuSubcategoryId: string;
}

export function removeMenuSubcategory(http: HttpClient, rootUrl: string, params: RemoveMenuSubcategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
  const rb = new RequestBuilder(rootUrl, removeMenuSubcategory.PATH, 'delete');
  if (params) {
    rb.path('menuCategoryId', params.menuCategoryId, {});
    rb.path('menuSubcategoryId', params.menuSubcategoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>;
    })
  );
}

removeMenuSubcategory.PATH = '/api/menu-categories/{menuCategoryId}/menu-subcategories/{menuSubcategoryId}';
